export const SIGN_IN = "Sign in";
export const HIDE = "Hide";
export const SHOW = "Show";
export const EMAIL = "Email";
export const PASSWORD = "Password";
export const EMAIL_REQUIRED = "Email address is required";
export const EMAIL_INVALID = "Email address is invalid";
export const PASSWORD_REQUIRED = "Password is required";
